import { Property } from "@flatfile/api/api";
import { FFValidator } from "src/utils";
import { INTEGER_VALIDATOR } from "./Validators";

export const TargetCommissionFields: Property[] = [
  {
    label: "Target Commission ($)",
    key: "targetCommission",
    type: "number",
  },
  {
    label: "Target Commission (% of Salary)",
    key: "targetCommissionPercent",
    type: "number",
  },
  {
    label: "Target Commission Notes",
    key: "targetCommissionNotes",
    type: "string",
  },
];

export const getTargetCommissionValidators = () => [
  FFValidator.regexMatches(
    "targetCommission",
    RegExp(INTEGER_VALIDATOR),
    "Must be a whole number"
  ),
];
